import React, { useEffect } from 'react';
import '../sass/home.sass';
import HeroSection from '../pages/home/HeroSection'
import KnowledgeSection from '../pages/home/KnowledgeSection'
import InfoSection from './home/InfoSection';
import ReferenceSection from './home/ReferenceSection';
import BannerSection from './home/BannerSection';


function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  return (
    <>
      <HeroSection />
      <InfoSection />
      <KnowledgeSection />
      <ReferenceSection />
      <BannerSection />
    </>
  );
}

export default Home;